#import "../../../../../../core-entity/graphql/fragments/account-for-core-entity-fragment.graphql"

query GetRelatedAccounts(
    $id: ID!
    $first: Int
    $after: String
    $formerOnly: Boolean
    $search: String
    $sortBy: PeepRelatedPeepSortType
) {
    contact(id: $id) {
        id
        accounts(
            first: $first
            after: $after
            formerOnly: $formerOnly
            search: $search
            sortBy: $sortBy
        ) {
            totalCount
            pageInfo {
                hasNextPage
                endCursor
            }
            primary {
                id
                name
            }
            edges {
                node {
                    ...AccountForCoreEntityFragment
                }
                isFormer
                relationshipNote
            }
        }
    }
}
